<!-- ============================================================
  ClosureManagement.vue — one page for both kinds of closure:
    • วันหยุด (studio-wide, whole day)  → HolidayManagment
    • ปิดรับจองรายคลาส (one class/date) → ClassDisableManagement
  A segmented toggle switches between the two; each child renders
  embedded (its own pg-head hidden) and its dialog/grid/logic are
  reused as-is. Child events are forwarded up to App.vue unchanged.
============================================================ -->
<template>
  <div>
    <div class="pg-head">
      <div class="pg-ico"><span class="mdi mdi-calendar-remove"></span></div>
      <div>
        <div class="id-h1">{{ $t('closures.title') }}</div>
        <div class="pg-sub">{{ $t('closures.subtitle') }}</div>
      </div>
    </div>

    <div class="closure-tabs">
      <button type="button" class="id-btn" :class="tab === 'holiday' ? 'id-btn-primary' : 'id-btn-ghost'" @click="tab = 'holiday'">
        <span class="mdi mdi-calendar-star"></span> {{ $t('closures.tabHoliday') }}
      </button>
      <button type="button" class="id-btn" :class="tab === 'class' ? 'id-btn-primary' : 'id-btn-ghost'" @click="tab = 'class'">
        <span class="mdi mdi-calendar-lock"></span> {{ $t('closures.tabClass') }}
      </button>
    </div>

    <holiday-managment v-if="tab === 'holiday'" embedded
      @onErrorHandler="$emit('onErrorHandler', $event)"
      @onInfoHandler="$emit('onInfoHandler', $event)"
      @onLoading="$emit('onLoading', $event)"></holiday-managment>
    <class-disable-management v-else embedded
      @onErrorHandler="$emit('onErrorHandler', $event)"
      @onInfoHandler="$emit('onInfoHandler', $event)"
      @onLoading="$emit('onLoading', $event)"></class-disable-management>
  </div>
</template>

<script>
import HolidayManagment from './HolidayManagment.vue'
import ClassDisableManagement from './ClassDisableManagement.vue'

export default {
  components: { HolidayManagment, ClassDisableManagement },
  emits: ['onErrorHandler', 'onInfoHandler', 'onLoading'],
  data: () => ({
    tab: 'holiday',
  }),
}
</script>

<style scoped>
.closure-tabs {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 18px;
}
</style>
